import React from 'react';
import type { QuizState } from '../types/quiz.types';
import { Info, CheckCircle2, AlertTriangle, XCircle, Flame } from 'lucide-react';

type FeedbackType = QuizState['feedbackType'];

interface FeedbackToastProps {
  visible: boolean;
  message: string | null;
  type: FeedbackType;
}

export const FeedbackToast: React.FC<FeedbackToastProps> = ({ visible, message, type }) => {
  if (!visible || !message) return null;

  return (
    <div className="pointer-events-none fixed z-50 top-14 left-1/2 -translate-x-1/2 animate-in fade-in slide-in-from-top-2 duration-300 w-full max-w-sm px-4">
      <div
        className={`px-4 py-2.5 rounded-xl border font-cyber text-xs sm:text-sm font-bold shadow-2xl flex items-center gap-2.5 backdrop-blur-md transition-all ${
          type === 'success'
            ? 'bg-slate-900/95 border-emerald-500/80 text-emerald-300 shadow-emerald-950/60'
            : type === 'duelo'
              ? 'bg-slate-900/95 border-amber-500/80 text-amber-300 shadow-amber-950/60'
              : type === 'warning'
                ? 'bg-slate-900/95 border-amber-500/80 text-amber-200 shadow-amber-950/60'
                : type === 'error'
                  ? 'bg-slate-900/95 border-red-500/80 text-red-300 shadow-red-950/60'
                  : 'bg-slate-900/95 border-sky-500/80 text-sky-200 shadow-sky-950/60'
        }`}
      >
        {type === 'success' && <CheckCircle2 size={18} className="text-emerald-400 shrink-0" />}
        {type === 'duelo' && <Flame size={18} className="text-amber-400 shrink-0 animate-pulse" />}
        {type === 'warning' && <AlertTriangle size={18} className="text-amber-400 shrink-0" />}
        {type === 'error' && <XCircle size={18} className="text-red-400 shrink-0" />}
        {type === 'info' && <Info size={18} className="text-sky-400 shrink-0" />}
        <span className="leading-snug flex-1">{message}</span>
      </div>
    </div>
  );
};
